export default __webpack_public_path__ + "static/media/pic4.3ffebc36.jpg";